import React, { ComponentState, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppInput } from "../../../components/Input";
import { ErrorConsts } from "../../../utils/ErrorCons";
import { AppButtons } from "../../../components/button";
import { forgotPassword } from "../../../redux/actions";
import CustomSnackbar from "../../../components/snackbar";
import { Checkbox } from "@mui/material";

export interface ForgotPasswordProps {
    onClose(): void,
    title?: string,
}

export const ForgotPassword: React.FC<ForgotPasswordProps> = ({ onClose, title }) => {
    const state: ComponentState = useSelector(states => {
        return states;
    });
    const dispatch = useDispatch()
    const [buttonPressed, setButtonPressed] = useState<boolean>(false)
    const [username, setUsername] = useState<string>()
    const [isUserParent, setUserParent] = useState(false)
    const { loadingState } = state['LoaderReducer'];
    const { forgotPasswordResponse } = state['AuthReducer']

    useEffect(() => {
        if (forgotPasswordResponse) {
            if (forgotPasswordResponse?.status === true) {
                setTimeout(() => {
                    onClose()
                }, 4000)
            }

        }
    })

    const handleButtonPressed = () => {
        setButtonPressed(true)
        if (username && username.length > 3) {
            dispatch(forgotPassword(username+'&isParent='+isUserParent))
        }

    }

    const handleClose = () => {
        onClose()

    }

    return (
        <>
            <div className="modal-wrapper">
                <div className="modal-Div my-3">
                    <button className="close-btn" onClick={handleClose}>
                        <i className="fa-regular fa-circle-xmark"></i>
                    </button>
                    <h2 className="mb-3 fw-600">{title}
                    </h2>
                    <form>
                        <AppInput labelText="Username"
                            inputType="text"
                            inputmode="text"
                            showError={buttonPressed && (!username || username.length < 4)}
                            errorMessage={ErrorConsts.USERNAME}
                            onChange={setUsername}></AppInput>

                        <div className="form-group">
                            <Checkbox
                                onChange={(event) => {
                                    setUserParent(event.target.checked)
                                }} />
                            <label className="fw-500" >{'This username is Parental Login?'}</label>
                        </div>
                        {forgotPasswordResponse &&

                            <p className={forgotPasswordResponse?.status ? "mb-3 mt-2 fw-600 success-message text-left m-0 f-14 fw-400 mb-0" : "mb-3 mt-2 fw-600 error-message text-left m-0 f-14 fw-400 mb-0"}> {forgotPasswordResponse?.message} </p>

                        }
                        <div className="d-flex gap-2 align-items-center">
                            <AppButtons buttonText="Submit" className="btn-common  btn-green" onclick={handleButtonPressed} loadingState={loadingState} ></AppButtons>
                            <AppButtons className="btn-common white-btn  text-center" buttonText="Cancel" onclick={handleClose} ></AppButtons>
                        </div>
                    </form>

                </div>
            </div>

        </>
    )
}